module.exports = __webpack_public_path__ + "static/media/tt7_in_tuinen_2021.46baae49.jpeg";